// hooks/useCustomerBreakdown.js
import { useQuery } from '@tanstack/react-query';
import { reactQueryFinanceDefaults } from './queryDefaults';
import apiService from '../../services/api';
import { ENDPOINTS } from '../../services/endpoints';

const useCustomerBreakdown = (dateRange) => {
  const fetchCustomerBreakdown = async () => {
    const response = await apiService.get(ENDPOINTS.FINANCE_CUSTOMER_BREAKDOWN, {
      start_date: dateRange.start_date,
      end_date: dateRange.end_date
    });
    return {
      customers: response?.customers || [],
      totalCustomers: response?.total_customers || 0,
      totalRetainers: response?.retainer_customers || 0,
      totalProjects: response?.project_customers || 0,
      lastUpdated: new Date().toISOString(),
    };
  };

  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
    } = useQuery({
      queryKey: ['customerBreakdown', dateRange.start_date, dateRange.end_date],
      queryFn: fetchCustomerBreakdown,
      ...reactQueryFinanceDefaults,
      enabled: !!dateRange?.start_date && !!dateRange?.end_date, // Only fetch if date range is provided
    });

  return {
    // Customer data
    customerBreakdown: data?.customers || [],
    totalCustomers: data?.totalCustomers || 0,
    totalRetainers: data?.totalRetainers || 0,
    totalProjects: data?.totalProjects || 0,
    lastUpdated: data?.lastUpdated || null,
    
    // Loading states
    loading: isLoading,
    refreshing: isFetching,
    
    // Error handling
    error: isError ? (error?.message || 'Failed to load customer breakdown') : null,
    isError,
    
    // Status
    initialized: !!data,
    
    // Actions
    refetch,
  };
};

export { useCustomerBreakdown };
